import { ServiceTypeEnum } from 'utils/enums';
import {
  mapChipFieldOptions,
  mapToggleFieldOptions,
  getOptions4Type,
} from 'features/consults/utils/formFields';
import fields from 'features/consults/shared/tabs/Data/formFields';

export const leftPanel = {
  elements: [
    mapToggleFieldOptions(fields.glucosePredefined),
    fields.glucoseFreeText,
    mapToggleFieldOptions(fields.creatininePredefined),
    fields.creatinineFreeText,
    mapToggleFieldOptions(fields.inrPredefined),
    fields.inrFreeText,
    fields.otherLabs,
  ],
};

export const rightPanel = {
  elements: [
    fields.headCtPersonallyReadAt,
    mapChipFieldOptions(
      getOptions4Type(fields.headCtPredefined, ServiceTypeEnum.NEURO),
    ),
    fields.headCtFreeText,
    fields.ctaPersonallyReviewedAt,
    mapToggleFieldOptions(fields.ctaHeadPredefined),
    mapToggleFieldOptions(fields.ctaHeadPreliminarilyPredefined),
    fields.ctaHeadFreeText,
    mapToggleFieldOptions(fields.ctaNeckPredefined),
    mapToggleFieldOptions(fields.ctaNeckPreliminarilyPredefined),
    fields.ctaNeckFreeText,
    fields.ctpPersonallyReviewedAt,
    mapChipFieldOptions(fields.ctPerfusionPredefined),
    mapToggleFieldOptions(fields.ctPerfusionPreliminarilyPredefined),
    fields.ctPerfusionFreeText,
    fields.mriPersonallyReviewedAt,
    mapToggleFieldOptions(fields.mriPredefined),
    mapToggleFieldOptions(fields.mriPreliminarilyPredefined),
    fields.mriFreeText,
    fields.otherImaging,
  ],
};
